<template>
  <div id="charts1"></div>
</template>
<script>
import echarts from "echarts";
export default {
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      const charts1 = echarts.init(document.getElementById('charts1'))
      const option = {
        grid: {
          top: '0',
          left: '2%',
          right: '25%',
          bottom: '0',
          containLabel: true
        },
        yAxis: [{
          type: 'category',
          data: ['Ajax', 'Java', 'Mysql', 'HTML', 'UDP', 'CSS', 'Mysql', 'HTML', 'HTML'],
          inverse: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 20,
            textStyle: {
              fontSize: 12,
              color: '#323232'
            }
          },
          axisLine: {
            show: false
          }
        }],
        xAxis: [{
          type: 'value',
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          type: 'bar',
          barWidth: 8,
          data: [90, 83, 90, 83, 90, 83, 90, 83, 83],
          label: {
            normal: {
              show: true,
              position: 'insideBottomRight',
              formatter: '覆盖率：{c}%',
              distance: 0,
              offset: [120, 13],
              color: '#969696',
              fontSize: 10,
              padding: [5, 15, 10, 15],
              rich: {}
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: '#03B187' // 0% 处的颜色
              }, {
                offset: 1,
                color: '#8EE9CA' // 100% 处的颜色
              }], false),
              barBorderRadius: 14
            }
          }
        },
        {
          type: "bar",
          barWidth: 8,
          xAxisIndex: 0,
          barGap: "-100%",
          data: [100, 100, 100, 100, 100, 100, 100, 100, 100,],
          itemStyle: {
            normal: {
              color: "#F4F4F4",
              barBorderRadius: 14
            }
          },
          zlevel: -1
        }]
      }
      charts1.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
  #charts1 {
    width: 100%;
    height: 460px;
  }
</style>